const currencies = [
  { name: "US Dollar", code: "USD", flag: "/images/flags/united-states.png" },
  { name: "Euro", code: "EUR", flag: "/images/flags/round.png" },
  {
    name: "British Pound Sterling",
    code: "GBP",
    flag: "/images/flags/united-kingdom.png",
  },
  { name: "Japanese Yen", code: "JPY", flag: "/images/flags/japan.png" },
  {
    name: "Australian Dollar",
    code: "AUD",
    flag: "/images/flags/australia.png",
  },
  { name: "Chinese Yuan", code: "CNY", flag: "/images/flags/china.png" },
  { name: "Indian Rupee", code: "INR", flag: "/images/flags/india.png" },
  {
    name: "Brazilian Real",
    code: "BRL",
    flag: "/images/flags/brazil-flag.png",
  },
  {
    name: "South African Rand",
    code: "ZAR",
    flag: "/images/flags/south-africa.png",
  },
  { name: "Mexican Peso", code: "MXN", flag: "/images/flags/mexico.png" },
  {
    name: "UAE Dirham",
    code: "AED",
    flag: "/images/flags/united-arab-emirates.png",
  },
  {
    name: "Saudi Riyal",
    code: "SAR",
    flag: "/images/flags/saudi-arabia.png",
  },
  { name: "Swiss Franc", code: "CHF", flag: "/images/flags/switzerland.png" },
  {
    name: "Singapore Dollar",
    code: "SGD",
    flag: "/images/flags/singapore.png",
  },
];

export default currencies;
